import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { Organization } from '../../../types/organization';
import CustomAxios from '../../../utility/customAxios';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';
import { mutationKeys } from '../mutationKeys';

export const updateOrganization = async (formData: Organization) => {
  const response = await CustomAxios.put(`organizations`, formData);
  const { data } = response;
  return data;
};

interface UseUpdateOrganizationFormProps {
  onSuccessCallback: () => void;
}
export function useUpdateCurrentOrganization({ onSuccessCallback }: UseUpdateOrganizationFormProps) {
  return useMutation({
    mutationKey: [mutationKeys.updateOrganization],
    mutationFn: (formData: Organization) => updateOrganization(formData),
    onSuccess: () => {
      // fetch the organization again after create
      queryClient.invalidateQueries({ queryKey: [queryKeys.currentOrganization] });

      // call success
      onSuccessCallback();
    },
    onError: (err: AxiosError) => {
      if (err?.response?.status === 400) {
        const data: Organization = err.response.data as Organization;
        queryClient.setQueryData([queryKeys.currentOrganization], data);
      }
    },
  });
}
